import { createFeatureSelector } from '@ngrx/store';

export const latestTransactionsState = createFeatureSelector<OLO.State, OLO.State.LatestTransaction[]>('latestTransactions');
